/**
 * The small shield that appears beside a price once a Kono super user unlocks
 * the tools. Drawn inline rather than shipped as an image so it inherits the
 * button's colour and stays crisp at 16px.
 */
export const ShieldMark = ({ className = "" }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    aria-hidden="true"
    className={className}
    fill="currentColor"
  >
    <path d="M12 2 4 5v6.2c0 5 3.4 9.6 8 10.8 4.6-1.2 8-5.8 8-10.8V5l-8-3Z" />
    <path
      d="M9 8.6h6l-2.1 2.6H15L9.6 16l.9-3.1H8.4L9 8.6Z"
      fill="#fff"
      stroke="none"
    />
  </svg>
);
